export const locale = {
    lang: 'de',
    data: {
      'FILEMANAGER': {
        'TITULO': 'Dateimanager',
        'SUBTI': 'Laden Sie Ihre firmenrelevanten Dateien hoch',
        'GPTW': {
          'TITULO': 'Klicken Sie auf einen Firmennamen, um die Liste der hochgeladenen Dateien anzuzeigen',
          'NUMFILES': 'Anzahl der hochgeladenen Dateien: '
        },
        'CT_NAME': 'Mitarbeiter, die ein schweres traumatisches Ereignis hatten',
        'LABEL01': 'Arbeitsstellen',
        'CARGA': {
          'TITULO': 'Klicken Sie hier, um eine Datei hochzuladen, oder ziehen Sie sie hier per Drag & Drop',
          'CARGANDOTIT': 'Hochladen',
          'CARGANTOTXT': 'Die Datei wird an die Datenbank gesendet. Bitte warten Sie einen Moment.'
        },
        'MENU': {
          'BOTON': 'Neu',
          'ARCHIVO': 'Datei',
          'CARPETA': 'Folder',
          'EXCELTI': 'Laden Sie Excel TI herunter'
        },
        'LISTA': {
          'TITULOS': {
            'NOMBRE': 'Name',
            'EXTEN': 'Erweiterung',
            'FECHA': 'Upload-Datum',
            'ACCIONES': 'Aktionen',
            'TAMANIO': 'Größe'
          },
           // Temporales
          'TITULOSENC':{
            'NOMBRE': 'Name des Mitarbeiters: ',
            'ARCH': 'Dateiname',
            'DATE': 'Aktualisierungsdatum',
            'EXTEN': 'Arbeitsplatzname: ',
            'ACT': 'Aktionen',
            'BT': 'Home'
          },
          'TOOLTIP': {
            'DESCARGA': 'Diese Datei herunterladen',
            'DELETE': 'Diese Datei löschen',
            'OPENFOLDER': 'Klicken Sie hier, um diesen Ordner zu öffnen',
            'VACIO': 'Dieser Ordner ist leer'
          }
        },
        'MENSAJES': {
          'CARGAOK': 'Die Datei wurde erfolgreich gespeichert',
          'CARGAREP': 'Die Datei wurde nicht gespeichert. Es existiert bereits eine Datei mit demselben Namen',
          'DELETERLY': 'Bestätigen Sie, dass die Datei gelöscht werden soll?',
          'DELETEOK': 'Die Datei wurde korrekt gelöscht',
          'CREATEFOLDER': 'Geben Sie den Namen für den neuen Ordner ein',
          'FOLDEROK': 'Der Ordner wurde erfolgreich erstellt.',
          'archivo_save_4': 'Der Ordner konnte nicht erstellt werden. Es existiert bereits ein Ordner mit demselben Namen',
          'DELETEFOLDERRLY': 'Bestätigen Sie, dass dieser Ordner gelöscht werden soll?\n\nWarnung: Der Inhalt dieses Ordners wird ebenfalls gelöscht',
          'DELETEFOLDEROK': 'Der Ordner mitsamt seinem Inhalt wurde erfolgreich gelöscht',
          'INVALID_CHARS': 'Der Ordnername darf nur Buchstaben von A bis Z und Ziffern enthalten',
          'BOTONES': {
            'SI': 'Ja',
            'NO': 'Nein',
            'ACEPTAR': 'Akzeptieren',
            'CREAR': 'Erstellen',
            'CANCELAR': 'Abbrechen'
          }
        },
        'CARPETASDEFAULT':{
          'Información TI': 'TI Information',
          'Información CA': 'CA Information',
          'Información General': 'Allgemeine Informationen',
          'Comunicación NOM035': 'NOM035 Kommunikation',
          'Listado de colaboradores NOM-035': 'NOM-035 Collaboratos List',
          'PDF de resultados NOM-035': 'NOM-035 Ergebnisse PDF',
          'Plantilla listado colaboradores': 'Vorlage für die Mitarbeiterliste',
          'Campaña de Comunicación 2020': 'Kommunikationskampagne',
          // 'Culture Audit': 'Kultur-Audit',
          'Guía de certificación': 'Leitfaden zur Zertifizierung',
          'Listado de colaboradores': 'Liste der Mitarbeiter',
          'Plantillas': 'Vorlagen',
          'Templates con TI': 'Vorlagen mit IT',
          'Templates Página': 'Seitenvorlagen',
          'Certificar' : 'Zertifizieren',
          'Focus Area' : 'Fokusbereich',
          'Medir' : 'Messen',
          'Pulsecheck' : 'Pulse Check',
          'Row Data': 'Zeilendaten',
          'Reports': 'Berichte',

          'Campana de Comunicacion': 'Kommunikationskampagne',
          'Culture Audit': 'Kultur-Audit™',
          'Great Book': 'Tolles Buch',
          'Cuestionarios': 'Fragebögen',
          'Pulse Check': 'Drücken Sie Prüfen',
          'Base de datos': 'Datenbank',
          'Practicas For All': 'Praktika für alle',
          'Reporte de Resultados': 'Ergebnisbericht',
          'Validacion': 'Validierung',
        }
      }
    }
};
